import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { SidebarStore } from './types';

const useSidebarStore = create(
  persist<SidebarStore>(
    (set, get) => ({
      isExpanded: false,
      expandedGroups: [],
      toggleSidebar: () => {
        const newExpanded = !get().isExpanded;
        set({
          isExpanded: newExpanded,
          expandedGroups: newExpanded ? get().expandedGroups : [],
        });
      },
      toggleGroup: (iconKey) => {
        const groups = get().expandedGroups;
        const newGroups = groups.includes(iconKey)
          ? groups.filter((g) => g !== iconKey)
          : [...groups, iconKey];
        set({ expandedGroups: newGroups });
      },
    }),
    {
      name: 'sidebar-storage',
      partialize: (state) => ({ isExpanded: state.isExpanded }) as SidebarStore,
    },
  ),
);

export default useSidebarStore;
